<template>

  <div>
    <b-modal
      v-model="modalOpen"
      footer-class="removed"
      centered
      no-close-on-backdrop
      v-bind="$attrs"
      v-on="$listeners"
      :title="mainTitle"
    >
      <slot name="body">
          
    <div class="">
      <validation-observer ref="branchValidation">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col cols="12">
              <form-select
                label="نوع العقوبة"
                :getOptionLabel="(x) => x.name"
                :reduce="(x) => x"
                id="punishments"
                ep="v2/selects/punishments"
                ref="punishments"
                rules="required"
                v-model="form.punishment_id"
              />
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col  cols="12 " class="mt-2">
                  <div class="d-flex justify-content-between">
                    <p>
                      المُرفقات :
                    </p>
                    <b-button
                      variant="outline-success"
                      @click="onClickedAdd"
                      size="sm"
                    >
                      <feather-icon icon="PlusIcon" />
                      إضافة
                    
                    </b-button>

                  </div>
                
                  <hr />
                </b-col>
                <b-col cols="12"  v-for="(file, fileId) in form.files" :key="fileId">
                  <b-row>
                    <b-col cols="6" class="my-1">
                      المُرفق {{ getArrangement(fileId+1) }}
                    </b-col>
                    <hr />
                    <b-col cols="6" class="d-flex justify-content-end align-items-start my-1">
                      <b-button
                        variant="outline-danger"
                        @click="onClickedDeleted(fileId)"
                        size="sm"
                        :disabled="fileId === 0"
                      >
                        <feather-icon icon="PlusIcon" />
                        حذف
                      
                      </b-button>
                    </b-col>
                    <b-col cols="12">
                      
                      <form-input
                        :placeholder= "`${fileId+1} - العنوان `"
                        v-model="file.name"
                        rules="required"
                        id="name"
                        
                        :readonly="fileId === 0"
                      />
                    </b-col>
                    <b-col cols="12">
                      <form-file-input
                        :placeholder="`${fileId+1} - الملف`"
                        id="document"
                        v-model="file.file"
                        rules="required"
                        accept=".doc,.pdf,.docx,.png"
                      />
                    </b-col>
                    <b-col cols="12" v-if="fileId !== form.files.length-1">
                      <hr />
                    </b-col>
                  </b-row>
                </b-col>
                  </b-row>
            </b-col>
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="success"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
      </slot>
    </b-modal>
  </div>
</template>


<script>

import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
  VBTooltip,
  
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import FormMask from "@/components/form-mask";
import { required, integer } from "@validations";
import mapSelect from "@/components/map-select";
import { ValidationProvider } from "vee-validate";
import FormImageInput from "@/components/FormImageInput.vue";
import { quillEditor } from "vue-quill-editor";
import FormFileInput from "@/components/FormFileInput.vue";
import FormCleave from "@/components/FormCleave.vue";
import FormTextarea from "@/components/form-textarea/index.vue";
import { arrangement } from "@/utils/utils";
import { mapActions, mapGetters } from "vuex";
// import store from "../pages/transactions/store";
const initForm = {};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    BSidebar,
    FormMask,
    saveBtn,
    BRow,
    BCol,
    mapSelect,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormImageInput , 
    quillEditor ,
    FormFileInput , 
    FormCleave ,
    FormTextarea
  },
  props: {
    value: Boolean,
    title: String,
    mainTitle: {
      type: String,
      default: () => "بيانات معاملة",
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      form: {},
      required,
      integer,
    };
  },
  
  mounted() {
    // this.fetchTransactionType()
    // this.$store.fetchTransactionType()
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          // this.init(this.intializeForm);
        });
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    async onSubmit() {
      await this.$refs.branchValidation.validate().then(async (success) => {
        if (success) {
          this.$emit("confirm", this.form);
        }
      });
    },
    getArrangement(num){
      return arrangement(num)
    },
    
    onClickedAdd(){
      console.log(this.form)
      if(!this.form.hasOwnProperty('files') || Object.keys(this.form.files).length === 0 ){
        this.form.files =[{}]
        this.init(this.form )
      }
      else if(Object.keys(this.form.files).length < 5  ){
        
        // check if any form station => open without save Data
        let i=0
        if(this.form.files.length === 0)
        {
          this.form.files.push({})
        }
        
        else{
          for(let item of this.form.files)
          {
            i +=1
            if(Object.keys(item).length === 0)
            {
              this.form.files.splice(i-1, 1) 
            }
          }
          this.form.files.push({})
        }
        this.isOver = false
      }
      else{
        this.isOver = true
      }
    },
  },
};
</script>
